import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { GET, POST, PUT, httpOk } from 'helpers/api'

function Index() {
	const { t } = useTranslation()

	const [botToken, setBotToken]       = useState('')
	const [testChatId, setTestChatId]   = useState('')
	const [saving, setSaving]           = useState(false)
	const [testing, setTesting]         = useState(false)
	const [saveStatus, setSaveStatus]   = useState(null)  // 'ok' | 'err'
	const [testStatus, setTestStatus]   = useState(null)  // 'ok' | 'err' | null
	const [testMessage, setTestMessage] = useState('')
	const [hasToken, setHasToken]       = useState(false)
	// Guruh holati: chat_id webhook orqali AVTOMAT bog'lanadi (guruhda /bind yozilganda),
	// shuning uchun bu yerda faqat ko'rsatiladi — qo'lda kiritilmaydi.
	const [group, setGroup]             = useState({ chat_id: null, title: null, linked: 0, total: 0 })
	const [manualGroup, setManualGroup] = useState('')   // zaxira: guruh ID sini qo'lda kiritish
	const [webhookInfo, setWebhookInfo] = useState(null) // setWebhook natijasi (ok / xato matni)

	// GURUH A'ZOLARI.
	// ⚠️ Telegram Bot API guruhning to'liq a'zolar ro'yxatini BERMAYDI (getChatMembers yo'q).
	// Shuning uchun ro'yxat inkremental: adminlar darrov (getChatAdministrators), qolganlar
	// guruhda yozgan/kirgan sari qo'shiladi. `total_in_group` bilan farqni ochiq ko'rsatamiz.
	const [members, setMembers]         = useState([])
	const [memberInfo, setMemberInfo]   = useState({ total: null, bot_is_admin: false, synced_at: null })
	const [pendingGroup, setPendingGroup] = useState(null) // tasdiq kutayotgan yangi guruh
	const [syncing, setSyncing]         = useState(false)
	const [syncMsg, setSyncMsg]         = useState(null)   // { type: 'ok'|'err', text }
	// Diagnostika: webhook haqiqatan chat_member ni oladimi, privacy mode qanday.
	// Bularsiz nosozlik JIMGINA bo'ladi — hech qanday xato chiqmaydi, shunchaki ishlamaydi.
	const [diag, setDiag]               = useState(null)
	const [diagLoading, setDiagLoading] = useState(false)

	/* SHIKOYAT OQIMI — MIJOZLAR uchun ALOHIDA bot (xodim botidan mustaqil).
	   token/username/guruh/mas'ul odam — hammasi shu blokda. */
	const [complaint, setComplaint]     = useState({ token: '', name: '', phone: '' })
	const [complaintSaving, setComplaintSaving] = useState(false)
	const [complaintSaved, setComplaintSaved]   = useState(false)
	const [complaintBot, setComplaintBot] = useState({ username: '', chat_id: null, title: null })
	const [complaintWebhook, setComplaintWebhook] = useState(null)

	/* HAMKOR ZAKAZ BOTI — ALOHIDA bot (2026-08-28, egasi: «alohida qilib ber»).
	   Shikoyat boti bilan bir xil oqim: token saqlanadi -> backend webhook o'rnatadi ->
	   bot hamkor guruhiga qo'shilganda guruh AVTOMAT bog'lanadi. */
	const [supplierToken, setSupplierToken] = useState('')
	const [supplierSaving, setSupplierSaving] = useState(false)
	const [supplierSaved, setSupplierSaved]   = useState(false)
	const [supplierBot, setSupplierBot] = useState({ username: '', chat_id: null, title: null })
	const [supplierWebhook, setSupplierWebhook] = useState(null)

	/* YUK BOTI (2026-09-01) — chiqib ketgan yuk rasmlari uchun ALOHIDA bot */
	const [shipmentToken, setShipmentToken] = useState('')
	const [shipmentSaving, setShipmentSaving] = useState(false)
	const [shipmentSaved, setShipmentSaved]   = useState(false)
	const [shipmentBot, setShipmentBot] = useState({ username: '', chat_id: null, title: null })
	const [shipmentWebhook, setShipmentWebhook] = useState(null)

	// Guruhni qo'lda saqlash — «/bind» faqat public HTTPS da ishlaydi, lokalda shu yo'l kerak
	async function saveManualGroup() {
		const res = await POST('/telegram-settings', { bot_token: botToken, group_chat_id: manualGroup.trim() }, { loader: true })
		if (httpOk(res)) {
			setManualGroup('')
			loadSettings()
			loadMembers()
		}
	}

	async function loadMembers() {
		const res = await GET('/telegram-group-members', {}, { loader: false })
		if (httpOk(res)) {
			setMembers(res.data?.members ?? [])
			setMemberInfo({
				total: res.data?.total_in_group ?? null,
				bot_is_admin: !!res.data?.bot_is_admin,
				synced_at: res.data?.synced_at ?? null,
			})
			setPendingGroup(res.data?.pending_chat_id
				? { chat_id: res.data.pending_chat_id, title: res.data.pending_title }
				: null)
		}
	}

	// Ro'yxatni Telegram'dan yangilash. getChatAdministrators — so'rovni BIZ yuboramiz,
	// shuning uchun webhook (public HTTPS) shart emas va lokalda ham ishlaydi.
	async function syncMembers() {
		setSyncing(true)
		setSyncMsg(null)
		const res = await POST('/telegram-group-members/sync', {}, { loader: false })
		setSyncing(false)
		if (httpOk(res)) {
			setSyncMsg({ type: 'ok', text: t('tg_sync_done', { admins: res.data?.admins ?? 0, known: res.data?.known ?? 0 }) })
			loadMembers()
		} else {
			setSyncMsg({ type: 'err', text: res?.data?.message || t('tg_test_failed') })
		}
	}

	// «Avtomat belgilanadi» — chek yuborilganda bu odam oldindan tanlangan bo'ladi
	// (bo'lim rahbari sotuvchi esdan chiqarsa ham chekni ko'radi).
	async function toggleDefault(m) {
		const res = await PUT(`/telegram-group-members/${m.id}/default`, { is_default: !m.is_default }, { loader: false })
		if (httpOk(res)) {
			setMembers((prev) => prev.map((x) => (x.id === m.id ? { ...x, is_default: !m.is_default } : x)))
		}
	}

	async function loadDiagnostics() {
		setDiagLoading(true)
		const res = await GET('/telegram-settings/diagnostics', {}, { loader: false })
		setDiagLoading(false)
		if (httpOk(res)) setDiag(res.data)
	}

	async function resolvePending(approve) {
		const url = approve ? '/telegram-group-members/approve-pending' : '/telegram-group-members/reject-pending'
		const res = await POST(url, {}, { loader: true })
		if (httpOk(res)) {
			setPendingGroup(null)
			loadSettings()
			loadMembers()
		}
	}


	useEffect(() => {
		loadSettings()
		loadMembers()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	async function loadSettings() {
		const res = await GET('/telegram-settings', {}, { loader: true })
		if (httpOk(res)) {
			const token = res.data?.bot_token || ''
			setBotToken(token)
			setHasToken(!!token)
			setGroup({
				chat_id: res.data?.group_chat_id || null,
				title: res.data?.group_title || null,
				linked: res.data?.employees_linked ?? 0,
				total: res.data?.employees_total ?? 0,
			})
			// Shikoyat oqimi — alohida bot (2026-08-17)
			setComplaint({
				token: res.data?.complaint_bot_token || '',
				name: res.data?.responsible_name || '',
				phone: res.data?.responsible_phone || '',
			})
			setComplaintBot({
				username: res.data?.complaint_bot_username || '',
				chat_id: res.data?.complaint_chat_id || null,
				title: res.data?.complaint_group_title || null,
			})
			// Hamkor zakaz oqimi — alohida bot (2026-08-28)
			setSupplierToken(res.data?.supplier_bot_token || '')
			setSupplierBot({
				username: res.data?.supplier_bot_username || '',
				chat_id: res.data?.supplier_chat_id || null,
				title: res.data?.supplier_group_title || null,
			})
			// Yuk boti (2026-09-01)
			setShipmentToken(res.data?.shipment_bot_token || '')
			setShipmentBot({
				username: res.data?.shipment_bot_username || '',
				chat_id: res.data?.shipment_chat_id || null,
				title: res.data?.shipment_group_title || null,
			})
		}
	}

	/* HAMKOR ZAKAZ BOTI — token saqlansa backend o'zi webhook o'rnatadi, kalit
	   yaratadi va bot nomini oladi. Guruh botni guruhga qo'shganda AVTOMAT bog'lanadi. */
	async function saveSupplierBot(e) {
		e.preventDefault()
		setSupplierSaving(true)
		const res = await POST('/telegram-settings', {
			supplier_bot_token: supplierToken.trim(),
		}, { loader: false })
		setSupplierSaving(false)
		if (httpOk(res)) {
			setSupplierSaved(true)
			setSupplierWebhook(res.data?.supplier_webhook ?? null)
			setTimeout(() => setSupplierSaved(false), 3000)
			loadSettings()
		}
	}

	/* Hamkor guruhini bo'shatish — bot boshqa guruhga jimgina ko'chmaydi,
	   shuning uchun almashtirishdan oldin shu yerdan tozalanadi. */
	async function clearSupplierGroup() {
		const res = await POST('/telegram-settings', { supplier_group_clear: true }, { loader: false })
		if (httpOk(res)) loadSettings()
	}

	/* YUK BOTI — token saqlansa backend o'zi webhook + kalit + bot nomini oladi.
	   Guruh QO'LDA kiritilmaydi: botni guruhga qo'shish yoki guruhda «/yuk». */
	async function saveShipmentBot(e) {
		e.preventDefault()
		setShipmentSaving(true)
		const res = await POST('/telegram-settings', {
			shipment_bot_token: shipmentToken.trim(),
		}, { loader: false })
		setShipmentSaving(false)
		if (httpOk(res)) {
			setShipmentSaved(true)
			setShipmentWebhook(res.data?.shipment_webhook ?? null)
			setTimeout(() => setShipmentSaved(false), 3000)
			loadSettings()
		}
	}

	async function clearShipmentGroup() {
		const res = await POST('/telegram-settings', { shipment_group_clear: true }, { loader: false })
		if (httpOk(res)) loadSettings()
	}

	/* SHIKOYAT BOTI — token saqlansa backend o'zi: webhook o'rnatadi, kalit yaratadi
	   va getMe orqali bot nomini oladi (QR havolasi shundan quriladi).
	   Guruh esa botni guruhga qo'shganda AVTOMAT bog'lanadi — chat_id qo'lda kiritilmaydi. */
	async function saveComplaintSettings(e) {
		e.preventDefault()
		setComplaintSaving(true)
		const res = await POST('/telegram-settings', {
			complaint_bot_token: complaint.token.trim(),
			responsible_name: complaint.name,
			responsible_phone: complaint.phone,
		}, { loader: false })
		setComplaintSaving(false)
		if (httpOk(res)) {
			setComplaintSaved(true)
			setComplaintWebhook(res.data?.complaint_webhook ?? null)
			setTimeout(() => setComplaintSaved(false), 3000)
			loadSettings()
		}
	}

	async function saveToken(e) {
		e.preventDefault()
		setSaving(true)
		setSaveStatus(null)
		const res = await POST('/telegram-settings', { bot_token: botToken }, { loader: false })
		setSaving(false)
		if (httpOk(res)) {
			setSaveStatus('ok')
			setHasToken(!!botToken.trim())
			// setWebhook natijasi — avval jim yutilardi va /bind nega ishlamaganini bilish qiyin edi
			setWebhookInfo(res.data?.webhook ?? null)
			setTimeout(() => setSaveStatus(null), 3000)
		} else {
			setSaveStatus('err')
		}
	}

	async function sendTest(e) {
		e.preventDefault()
		setTesting(true)
		setTestStatus(null)
		setTestMessage('')
		// Guruh bog'langan bo'lsa — unga, aks holda qo'lda kiritilgan ID ga
		const res = await POST('/telegram-settings/test', { chat_id: group.chat_id || testChatId }, { loader: false })
		setTesting(false)
		if (httpOk(res)) {
			setTestStatus('ok')
			setTestMessage(t('tg_test_success'))
		} else {
			setTestStatus('err')
			setTestMessage(res?.data?.message || t('tg_test_failed'))
		}
	}

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('telegram_settings')}
				</h4>
			</div>

			<div className="row">
				<div className="col-md-7 col-lg-6">

					{/* Step 1 — How to get bot token */}
					<div className="card mb-3">
						<div className="card-body">
							<h6 className="fw-bold mb-3">
								<span className="badge bg-primary me-2">1</span>
								{t('tg_step1_title')}
							</h6>
							<ol className="ps-3 mb-0" style={{ lineHeight: '1.9', color: '#555', fontSize: '14px' }}>
								<li>{t('tg_step1_1')} <a href="https://t.me/BotFather" target="_blank" rel="noreferrer">@BotFather</a></li>
								<li>{t('tg_step1_2')}: <code>/newbot</code></li>
								<li>{t('tg_step1_3')}</li>
								<li>{t('tg_step1_4')}</li>
							</ol>
						</div>
					</div>

					{/* Step 2 — Enter bot token */}
					<div className="card mb-3">
						<div className="card-body">
							<h6 className="fw-bold mb-3">
								<span className="badge bg-primary me-2">2</span>
								{t('tg_step2_title')}
							</h6>

							{hasToken && (
								<div className="alert alert-success py-2 mb-3" style={{ fontSize: '13px' }}>
									<i className="uil uil-check-circle me-1"></i>
									{t('tg_token_saved')}
								</div>
							)}

							<form onSubmit={saveToken} autoComplete="off">
								<div className="form-group mb-3">
									<label className="form-label">{t('tg_bot_token')}</label>
									<input
										type="text"
										className="form-control font-monospace"
										placeholder="1234567890:AABBcc..."
										value={botToken}
										onChange={e => setBotToken(e.target.value)}
										style={{ fontSize: '13px', letterSpacing: '0.5px' }}
									/>
									<div className="form-text">{t('tg_token_hint')}</div>
								</div>

								{saveStatus === 'ok' && (
									<div className="alert alert-success py-2 mb-2" style={{ fontSize: '13px' }}>
										<i className="uil uil-check me-1"></i> {t('saved')}
									</div>
								)}
								{saveStatus === 'err' && (
									<div className="alert alert-danger py-2 mb-2" style={{ fontSize: '13px' }}>
										<i className="uil uil-exclamation-triangle me-1"></i> {t('tg_save_error')}
									</div>
								)}

								{/* Webhook holati — /bind ishlashi shunga bog'liq */}
								{webhookInfo && !webhookInfo.ok && (
									<div className="alert alert-warning py-2 mb-2" style={{ fontSize: '12.5px' }}>
										<i className="uil uil-exclamation-triangle me-1"></i>
										<b>{t('tg_webhook_failed')}</b>
										<div className="text-muted mt-1">{webhookInfo.message}</div>
										<div className="font-monospace mt-1" style={{ fontSize: '11.5px' }}>{webhookInfo.url}</div>
										<div className="mt-1">{t('tg_webhook_https_hint')}</div>
									</div>
								)}

								<button
									type="submit"
									className="btn btn-primary"
									disabled={saving}>
									{saving
										? <><span className="spinner-border spinner-border-sm me-2"></span>{t('saving')}</>
										: t('save')}
								</button>
							</form>
						</div>
					</div>

					{/* Step 3 — Guruhni ulash (AVTOMAT, chat_id qo'lda izlanmaydi) */}
					<div className="card mb-3">
						<div className="card-body">
							<h6 className="fw-bold mb-3">
								<span className="badge bg-primary me-2">3</span>
								{t('tg_bind_title')}
							</h6>

							{group.chat_id ? (
								<div className="alert alert-success py-2 mb-3" style={{ fontSize: '13px' }}>
									<i className="uil uil-check-circle me-1"></i>
									<b>{t('tg_group_connected')}</b>
									{group.title ? <>: {group.title}</> : null}
									<div className="text-muted font-monospace" style={{ fontSize: '11.5px' }}>{group.chat_id}</div>
								</div>
							) : (
								<div className="alert alert-warning py-2 mb-3" style={{ fontSize: '13px' }}>
									<i className="uil uil-info-circle me-1"></i>{t('tg_group_not_connected')}
								</div>
							)}

							{/* Bot boshqa guruhga qo'shildi — guruh AVTOMAT almashmaydi.
							    Sabab: bot username'i ommaviy, begona odam botni o'z guruhiga
							    qo'shsa cheklar (mijoz, telefon, narx) unga ketib qolardi.
							    Almashtirish faqat shu yerda — ERP ichida tasdiqlanadi. */}
							{pendingGroup ? (
								<div className="alert alert-warning py-2 mb-3" style={{ fontSize: '13px' }}>
									<div className="mb-2">
										<i className="uil uil-exclamation-triangle me-1"></i>
										<b>{t('tg_pending_group')}</b>
										{pendingGroup.title ? <>: {pendingGroup.title}</> : null}
										<div className="text-muted font-monospace" style={{ fontSize: '11.5px' }}>{pendingGroup.chat_id}</div>
									</div>
									<div className="mb-2">{t('tg_pending_group_hint')}</div>
									<button type="button" className="btn btn-primary btn-sm me-2" onClick={() => resolvePending(true)}>
										{t('tg_pending_approve')}
									</button>
									<button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => resolvePending(false)}>
										{t('tg_pending_reject')}
									</button>
								</div>
							) : null}

							<ol className="ps-3 mb-2" style={{ lineHeight: '1.9', color: '#555', fontSize: '14px' }}>
								<li>{t('tg_bind_1')}</li>
								<li>{t('tg_bind_2')}: <code>/bind</code></li>
								<li>{t('tg_bind_3')}</li>
							</ol>

							<div className="form-text mb-3">{t('tg_bind_hint')}</div>

							{/* Ikkisi ham kerak: pendingGroup («Bot yangi guruhga qo'shildi» banneri) va
							    a'zolar holati FAQAT loadMembers() javobidan to'ladi — avval bu tugma
							    faqat loadSettings() ni chaqirardi va banner hech qachon chiqmasdi. */}
							<button type="button" className="btn btn-outline-primary btn-sm mb-3"
								onClick={() => { loadSettings(); loadMembers() }}>
								<i className="uil uil-refresh me-1"></i>{t('refresh')}
							</button>

							{/* ZAXIRA: guruh ID sini qo'lda kiritish.
							    «/bind» faqat PUBLIC HTTPS manzilda ishlaydi — lokal muhitda
							    (http://localhost) Telegram webhook'ga yeta olmaydi. */}
							<details>
								<summary className="text-muted" style={{ fontSize: '12.5px', cursor: 'pointer' }}>
									{t('tg_manual_group')}
								</summary>
								<div className="mt-2">
									<div className="input-group">
										<input type="text" className="form-control font-monospace"
											placeholder="-1001234567890" value={manualGroup}
											onChange={(e) => setManualGroup(e.target.value)}
											style={{ fontSize: '13px' }} />
										<button className="btn btn-outline-primary" type="button"
											disabled={!manualGroup.trim()} onClick={() => saveManualGroup()}>
											{t('save')}
										</button>
									</div>
									<div className="form-text">{t('tg_manual_group_hint')}</div>
								</div>
							</details>
						</div>
					</div>

					{/* Step 4 — GURUH A'ZOLARI (chek yuborishda kimni teglash) */}
					<div className="card mb-3">
						<div className="card-body">
							<h6 className="fw-bold mb-3">
								<span className="badge bg-primary me-2">4</span>
								{t('tg_members_title')}
							</h6>

							{/* Ro'yxat NEGA to'liq emasligi ochiq yozilgan — Telegram cheklovi */}
							<div className="alert alert-light border py-2 mb-3" style={{ fontSize: '13px' }}>
								<i className="uil uil-info-circle me-1"></i>{t('tg_members_limit')}
							</div>

							{/* ⚠️ Faqat BIR MARTA sinxronlashdan KEYIN ko'rsatiladi: bot_is_admin ustuni
							    boshida FALSE turadi, ya'ni tekshirmasdan ogohlantirish YOLG'ON bo'lardi. */}
							{group.chat_id && memberInfo.synced_at && !memberInfo.bot_is_admin ? (
								<div className="alert alert-warning py-2 mb-3" style={{ fontSize: '13px' }}>
									<i className="uil uil-exclamation-triangle me-1"></i>{t('tg_bot_not_admin')}
								</div>
							) : null}

							<div className="d-flex align-items-center mb-3">
								<button type="button" className="btn btn-outline-primary btn-sm"
									disabled={syncing || !group.chat_id} onClick={() => syncMembers()}>
									{syncing
										? <><span className="spinner-border spinner-border-sm me-1"></span>{t('tg_members_syncing')}</>
										: <><i className="uil uil-refresh me-1"></i>{t('tg_members_sync')}</>}
								</button>
								<span className="text-muted ms-3" style={{ fontSize: '13px' }}>
									{t('tg_members_known')}: <b>{members.length}</b>
									{memberInfo.total !== null ? <> · {t('tg_members_in_group')}: {memberInfo.total}</> : null}
								</span>
							</div>

							{/* Faqat MUVAFFAQIYAT xabari — xatoni httpStatusChecker allaqachon
							    toast qilib ko'rsatadi (ikki marta chiqmasin). */}
							{syncMsg && syncMsg.type === 'ok' ? (
								<div className="alert alert-success py-2 mb-3" style={{ fontSize: '13px' }}>
									{syncMsg.text}
								</div>
							) : null}

							{members.length > 0 ? (
								<div className="table-responsive">
									<table className="table table-sm mb-0">
										<thead>
											<tr>
												<th>{t('name')}</th>
												<th>{t('tg_username_field')}</th>
												<th className="text-center" style={{ width: '130px' }}>{t('tg_members_default')}</th>
											</tr>
										</thead>
										<tbody>
											{members.map((m) => (
												<tr key={m.id}>
													<td>
														{m.employee_name || [m.first_name, m.last_name].filter(Boolean).join(' ') || m.telegram_id}
														{m.position_name ? <div className="text-muted" style={{ fontSize: '11.5px' }}>{m.position_name}</div> : null}
													</td>
													<td className="text-muted" style={{ fontSize: '12.5px' }}>
														{m.username ? `@${m.username}` : '—'}
													</td>
													<td className="text-center">
														{/* Belgilangan odam chek yuborilganda OLDINDAN tanlangan bo'ladi */}
														<input type="checkbox" className="form-check-input"
															checked={!!m.is_default} onChange={() => toggleDefault(m)} />
													</td>
												</tr>
											))}
										</tbody>
									</table>
								</div>
							) : (
								<div className="text-muted" style={{ fontSize: '13px' }}>{t('tg_members_empty')}</div>
							)}

							{/* DIAGNOSTIKA — nosozlik JIMGINA bo'lganda yagona ko'rish yo'li.
							    Ayniqsa `chat_member`: setWebhook allowed_updates ga yozilmasa
							    Telegram uni yubormaydi va hech qanday xato chiqmaydi. */}
							<hr className="my-3" />
							<button type="button" className="btn btn-outline-secondary btn-sm"
								disabled={diagLoading} onClick={() => loadDiagnostics()}>
								{diagLoading
									? <><span className="spinner-border spinner-border-sm me-1"></span>{t('tg_testing')}</>
									: <><i className="uil uil-stethoscope me-1"></i>{t('tg_diag')}</>}
							</button>

							{diag ? (
								<div className="mt-3" style={{ fontSize: '12.5px' }}>
									<table className="table table-sm mb-0">
										<tbody>
											<tr>
												<td className="text-muted">Webhook</td>
												<td className="font-monospace" style={{ wordBreak: 'break-all' }}>
													{diag.webhook?.url || <span className="text-danger">{t('tg_diag_no_webhook')}</span>}
												</td>
											</tr>
											<tr>
												<td className="text-muted">chat_member</td>
												<td>
													{diag.webhook?.has_chat_member
														? <span className="text-success">✓ {t('tg_diag_ok')}</span>
														: <span className="text-danger">✕ {t('tg_diag_no_chat_member')}</span>}
												</td>
											</tr>
											<tr>
												<td className="text-muted">{t('tg_diag_privacy')}</td>
												<td>{diag.bot?.can_read_all_group_messages ? t('tg_diag_privacy_off') : t('tg_diag_privacy_on')}</td>
											</tr>
											{diag.webhook?.last_error_message ? (
												<tr>
													<td className="text-muted">{t('error')}</td>
													<td className="text-danger">{diag.webhook.last_error_message}</td>
												</tr>
											) : null}
											<tr>
												<td className="text-muted">{t('tg_diag_pending')}</td>
												<td>{diag.webhook?.pending_update_count ?? 0}</td>
											</tr>
										</tbody>
									</table>
								</div>
							) : null}
						</div>
					</div>

					{/* Step 5 — Test connection */}
					<div className="card mb-3">
						<div className="card-body">
							<h6 className="fw-bold mb-3">
								<span className="badge bg-success me-2">5</span>
								{t('tg_step4_title')}
							</h6>
							<form onSubmit={sendTest} autoComplete="off">
								{/* chat_id QO'LDA kiritilmaydi — 3-qadamda bog'langan guruhga yuboriladi.
								    Guruh hali bog'lanmagan bo'lsa, sinov uchun qo'lda kiritish qoladi. */}
								{group.chat_id ? (
									<div className="mb-3" style={{ fontSize: '13px' }}>
										<span className="text-muted">{t('tg_group')}: </span>
										<b>{group.title || group.chat_id}</b>
									</div>
								) : (
									<div className="form-group mb-3">
										<label className="form-label">{t('tg_chat_id')}</label>
										<input
											type="text"
											className="form-control font-monospace"
											placeholder="-1001234567890"
											value={testChatId}
											onChange={e => setTestChatId(e.target.value)}
											style={{ fontSize: '13px' }}
										/>
										<div className="form-text">{t('tg_chatid_hint')}</div>
									</div>
								)}

								{testStatus === 'ok' && (
									<div className="alert alert-success py-2 mb-2" style={{ fontSize: '13px' }}>
										<i className="uil uil-check-circle me-1"></i> {testMessage}
									</div>
								)}
								{testStatus === 'err' && (
									<div className="alert alert-danger py-2 mb-2" style={{ fontSize: '13px' }}>
										<i className="uil uil-exclamation-triangle me-1"></i> {testMessage}
									</div>
								)}

								<button
									type="submit"
									className="btn btn-outline-primary"
									disabled={testing || !hasToken || !(group.chat_id || testChatId.trim())}>
									{testing
										? <><span className="spinner-border spinner-border-sm me-2"></span>{t('tg_testing')}</>
										: <><i className="uil uil-telegram me-1"></i>{t('tg_send_test')}</>}
								</button>
							</form>
						</div>
					</div>

					{/* ═══ SHIKOYAT VA TAKLIFLAR (2026-08-15) ═══
					    Mijoz A5 plakatdagi QR ni skanerlaydi -> bot shikoyat rejimida ochiladi.
					    Bu yerda: shikoyat tushadigan guruh + plakatga chiqadigan mas'ul odam. */}
					<div className="card mb-3">
						<div className="card-body">
							<h5 className="mb-1">
								<i className="uil uil-comment-alt-exclamation me-1 text-primary"></i>
								{t('complaint_settings')}
							</h5>
							<p className="text-muted fz-14">{t('responsible_hint')}</p>

							{/* 3 qadam: bot yaratish -> token -> guruhga qo'shish */}
							<ol className="ps-3 mb-3" style={{ lineHeight: '1.9', color: '#555', fontSize: '14px' }}>
								<li>{t('cb_step_1')} <a href="https://t.me/BotFather" target="_blank" rel="noopener noreferrer">@BotFather</a> → <code>/newbot</code></li>
								<li>{t('cb_step_2')}</li>
								<li>{t('cb_step_3')}</li>
							</ol>

							<form onSubmit={saveComplaintSettings} autoComplete="off">
								<div className="row">
									<div className="form-group col-md-4">
										<label>{t('complaint_bot_token')}</label>
										<input type="text" className="form-control font-monospace"
											placeholder="123456789:AAF..."
											value={complaint.token}
											onChange={(e) => setComplaint({ ...complaint, token: e.target.value })} />
										<div className="text-muted fz-14 mt-1">{t('complaint_bot_token_hint')}</div>
									</div>
									<div className="form-group col-md-4">
										<label>{t('responsible_name')}</label>
										<input type="text" className="form-control"
											value={complaint.name}
											onChange={(e) => setComplaint({ ...complaint, name: e.target.value })} />
									</div>
									<div className="form-group col-md-4">
										<label>{t('responsible_phone')}</label>
										<input type="text" className="form-control" placeholder="+998 90 123 45 67"
											value={complaint.phone}
											onChange={(e) => setComplaint({ ...complaint, phone: e.target.value })} />
									</div>
								</div>

								<div className="mt-3 d-flex gap-2 align-items-center">
									<button type="submit" className="btn btn-primary" disabled={complaintSaving}>
										{t('save')}
									</button>
									{complaintSaved &&
										<span className="text-success">
											<i className="uil uil-check-circle me-1"></i>{t('success')}
										</span>
									}
								</div>
							</form>

							{/* Holat: bot nomi, guruh, webhook */}
							{(!!complaintBot.username || !!complaintWebhook) &&
								<div className="mt-3 p-3" style={{ background: '#f8f9fa', borderRadius: '6px' }}>
									{!!complaintBot.username &&
										<div className="fz-14 mb-1">
											<i className="uil uil-robot me-1 text-primary"></i>
											<b>{t('bot')}:</b>{' '}
											<a href={`https://t.me/${complaintBot.username}`}
												target="_blank" rel="noopener noreferrer">
												@{complaintBot.username}
											</a>
											{' — '}{t('poster_button')}: <code>https://t.me/{complaintBot.username}</code>
										</div>
									}
									<div className="fz-14 mb-1">
										{complaintBot.chat_id
											? <><i className="uil uil-check-circle me-1 text-success"></i>
												<b>{t('group')}:</b> {complaintBot.title || complaintBot.chat_id}</>
											: <><i className="uil uil-exclamation-triangle me-1 text-warning"></i>
												{t('cb_group_missing')}</>
										}
									</div>
									{!!complaintWebhook &&
										<div className="fz-14">
											{complaintWebhook.ok
												? <span className="text-success"><i className="uil uil-check-circle me-1"></i>webhook ok</span>
												: <span className="text-danger">
													<i className="uil uil-times-circle me-1"></i>
													webhook: {complaintWebhook.message || 'xato'}
												</span>
											}
										</div>
									}
								</div>
							}
						</div>
					</div>

					{/* ═══ HAMKOR ZAKAZ BOTI — ALOHIDA bot (2026-08-28) ═══
					    Egasi: «hamkor zakaz botini alohida qilib ber». Asosiy (xodim/chek)
					    va shikoyat botlaridan mustaqil: o'z tokeni, o'z guruhi.
					    Guruh QO'LDA kiritilmaydi — botni guruhga qo'shish bilan bog'lanadi. */}
					<div className="card mb-3">
						<div className="card-body">
							<h5 className="mb-1">
								<i className="uil uil-truck me-2 text-primary"></i>
								{t('supplier_bot_settings')}
							</h5>
							<p className="text-muted fz-14">{t('supplier_bot_hint')}</p>

							<ol className="ps-3 mb-3" style={{ lineHeight: '1.9', color: '#555', fontSize: '14px' }}>
								<li>{t('sb_step_1')} <a href="https://t.me/BotFather" target="_blank" rel="noopener noreferrer">@BotFather</a> → <code>/newbot</code></li>
								<li>{t('sb_step_2')}</li>
								<li>{t('sb_step_3')}</li>
							</ol>

							<form onSubmit={saveSupplierBot} autoComplete="off">
								<div className="row">
									<div className="form-group col-md-6">
										<label>{t('supplier_bot_token')}</label>
										<input type="text" className="form-control font-monospace"
											placeholder="123456789:AAF..."
											value={supplierToken}
											onChange={(e) => setSupplierToken(e.target.value)} />
									</div>
								</div>

								<div className="mt-3 d-flex gap-2 align-items-center">
									<button type="submit" className="btn btn-primary" disabled={supplierSaving}>
										{t('save')}
									</button>
									{supplierSaved &&
										<span className="text-success">
											<i className="uil uil-check-circle me-1"></i>{t('success')}
										</span>
									}
								</div>
							</form>

							{/* Holat: bot nomi, bog'langan guruh, webhook */}
							{(!!supplierBot.username || !!supplierWebhook || !!supplierBot.chat_id) &&
								<div className="mt-3 p-3" style={{ background: '#f8f9fa', borderRadius: '6px' }}>
									{!!supplierBot.username &&
										<div className="fz-14 mb-1">
											<i className="uil uil-robot me-1 text-primary"></i>
											<b>{t('bot')}:</b>{' '}
											<a href={`https://t.me/${supplierBot.username}`}
												target="_blank" rel="noopener noreferrer">
												@{supplierBot.username}
											</a>
										</div>
									}
									<div className="fz-14 mb-1 d-flex align-items-center gap-2 flex-wrap">
										{supplierBot.chat_id
											? <>
												<span>
													<i className="uil uil-check-circle me-1 text-success"></i>
													<b>{t('group')}:</b> {supplierBot.title || supplierBot.chat_id}
												</span>
												<button type="button" className="btn btn-sm btn-outline-danger py-0 px-2"
													style={{ fontSize: 12 }}
													onClick={clearSupplierGroup}>
													{t('sb_group_clear')}
												</button>
											</>
											: <span>
												<i className="uil uil-exclamation-triangle me-1 text-warning"></i>
												{t('sb_group_missing')}
											</span>
										}
									</div>
									{!!supplierWebhook &&
										<div className="fz-14">
											{supplierWebhook.ok
												? <span className="text-success"><i className="uil uil-check-circle me-1"></i>webhook ok</span>
												: <span className="text-danger">
													<i className="uil uil-times-circle me-1"></i>
													webhook: {supplierWebhook.message || 'xato'}
												</span>
											}
										</div>
									}
								</div>
							}
						</div>
					</div>

					{/* ═══ YUK BOTI — ALOHIDA bot (2026-09-01) ═══
					    Egasi: «har bir chiqib ketayotgan yukni rasmga olib yuborish kerak —
					    omborchi buni Telegram orqali qiladi, guruhda ham saqlanadi, dasturda
					    ham kelib tushadi». O'g'irlik profilaktikasi va nizoda dalil.
					    Rasm MAJBURIY EMAS — yo'qligi kun yakunida ko'rinadi. */}
					<div className="card mb-3">
						<div className="card-body">
							<h5 className="mb-1">
								<i className="uil uil-camera me-2 text-primary"></i>
								{t('shipment_bot_settings')}
							</h5>
							<p className="text-muted fz-14">{t('shipment_bot_hint')}</p>

							<ol className="ps-3 mb-3" style={{ lineHeight: '1.9', color: '#555', fontSize: '14px' }}>
								<li>{t('shb_step_1')} <a href="https://t.me/BotFather" target="_blank" rel="noopener noreferrer">@BotFather</a> → <code>/newbot</code></li>
								<li>{t('shb_step_2')}</li>
								<li>{t('shb_step_3')}</li>
							</ol>

							<form onSubmit={saveShipmentBot} autoComplete="off">
								<div className="row">
									<div className="form-group col-md-6">
										<label>{t('shipment_bot_token')}</label>
										<input type="text" className="form-control font-monospace"
											placeholder="123456789:AAF..."
											value={shipmentToken}
											onChange={(e) => setShipmentToken(e.target.value)} />
									</div>
								</div>

								<div className="mt-3 d-flex gap-2 align-items-center">
									<button type="submit" className="btn btn-primary" disabled={shipmentSaving}>
										{t('save')}
									</button>
									{shipmentSaved &&
										<span className="text-success">
											<i className="uil uil-check-circle me-1"></i>{t('success')}
										</span>
									}
								</div>
							</form>

							{(!!shipmentBot.username || !!shipmentWebhook || !!shipmentBot.chat_id) &&
								<div className="mt-3 p-3" style={{ background: '#f8f9fa', borderRadius: '6px' }}>
									{!!shipmentBot.username &&
										<div className="fz-14 mb-1">
											<i className="uil uil-robot me-1 text-primary"></i>
											<b>{t('bot')}:</b>{' '}
											<a href={`https://t.me/${shipmentBot.username}`}
												target="_blank" rel="noopener noreferrer">
												@{shipmentBot.username}
											</a>
										</div>
									}
									<div className="fz-14 mb-1 d-flex align-items-center gap-2 flex-wrap">
										{shipmentBot.chat_id
											? <>
												<span>
													<i className="uil uil-check-circle me-1 text-success"></i>
													<b>{t('group')}:</b> {shipmentBot.title || shipmentBot.chat_id}
												</span>
												<button type="button" className="btn btn-sm btn-outline-danger py-0 px-2"
													style={{ fontSize: 12 }}
													onClick={clearShipmentGroup}>
													{t('sb_group_clear')}
												</button>
											</>
											: <span>
												<i className="uil uil-exclamation-triangle me-1 text-warning"></i>
												{t('shb_group_missing')}
											</span>
										}
									</div>
									{!!shipmentWebhook &&
										<div className="fz-14">
											{shipmentWebhook.ok
												? <span className="text-success"><i className="uil uil-check-circle me-1"></i>webhook ok</span>
												: <span className="text-danger">
													<i className="uil uil-times-circle me-1"></i>
													webhook: {shipmentWebhook.message || 'xato'}
												</span>
											}
										</div>
									}
								</div>
							}
						</div>
					</div>


					{/* Info — Where to use Chat ID */}
					<div className="card border-0" style={{ background: '#f8f9fa' }}>
						<div className="card-body py-3">
							<p className="mb-0 text-muted" style={{ fontSize: '13px' }}>
								<i className="uil uil-info-circle me-1 text-primary"></i>
								{t('tg_usage_hint')}
							</p>
						</div>
					</div>

				</div>
			</div>
		</>
	)
}

export default Index
